import { combineEpics } from "redux-observable";
import { epicCoopAssignMemberRole } from "./epic/epicCoopAssignMemberRole";
import { epicCoopBuffs } from "./epic/epicCoopBuffs";
import { epicCoopCollectPoints } from "./epic/epicCoopCollectPoints";
import { epicCoopEdit } from "./epic/epicCoopEdit";
import { epicCoopFound } from "./epic/epicCoopFound";
import { epicCoopGetEventNotices } from "./epic/epicCoopGetEventNotices";
import { epicCoopHudButtonClicked } from "./epic/epicCoopHudButtonClicked";
import { epicCoopInfo } from "./epic/epicCoopInfo";
import { epicCoopInfoSetProjectAccessTime } from "./epic/epicCoopInfoSetProjectAccessTime";
import { epicCoopInviteInfo } from "./epic/epicCoopInviteInfo";
import { epicCoopInvitePlayer } from "./epic/epicCoopInvitePlayer";
import { epicCoopJoin } from "./epic/epicCoopJoin";
import { epicCoopJoinableCoopList } from "./epic/epicCoopJoinableCoopList";
import { epicCoopJoinCoop } from "./epic/epicCoopJoinCoop";
import { epicCoopKickMember } from "./epic/epicCoopKickMember";
import { epicCoopLeave } from "./epic/epicCoopLeave";
import { epicCoopMemberOtherCoop } from "./epic/epicCoopMemberOtherCoop";
import { epicCoopMembers } from "./epic/epicCoopMembers";
import { epicCoopMenuTabGoTo } from "./epic/epicCoopMenuTabGoTo";
import { epicCoopPlayerCancelInvite } from "./epic/epicCoopPlayerCancelInvite";
import { epicCoopPointsInfoRequest } from "./epic/epicCoopPointsInfoRequest";
import { epicCoopProjectInfo } from "./epic/epicCoopProjectInfo";
import { epicCoopProjectStart } from "./epic/epicCoopProjectStart";
import { epicCoopProjectStop } from "./epic/epicCoopProjectStop";
import { epicCoopProjectTypeInfoRequest } from "./epic/epicCoopProjectTypeInfoRequest";
import { epicCoopSearch } from "./epic/epicCoopSearch";
import { epicCoopSendPoints } from "./epic/epicCoopSendPoints";
import { epicCoopUpdateMessage } from "./epic/epicCoopUpdateMessage";
import { epicSelectNoticesTab } from "./epic/epicSelectNoticesTab";
export var epicCoop = combineEpics(epicCoopInfo, epicCoopBuffs, epicCoopInviteInfo, epicCoopPlayerCancelInvite, epicCoopFound, epicCoopEdit, epicCoopUpdateMessage, epicCoopGetEventNotices, epicCoopJoinCoop, epicCoopSearch, epicCoopJoinableCoopList, epicCoopMembers, epicCoopLeave, epicCoopMenuTabGoTo, epicCoopHudButtonClicked, epicCoopPointsInfoRequest, epicCoopSendPoints, epicCoopCollectPoints, epicCoopKickMember, epicCoopAssignMemberRole, epicCoopProjectStart, epicCoopProjectStop, epicCoopProjectInfo, epicCoopProjectTypeInfoRequest, epicCoopInvitePlayer, epicCoopJoin, epicCoopMemberOtherCoop, epicCoopInfoSetProjectAccessTime, epicSelectNoticesTab);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epicCoop.ts
// module id = 1796
// module chunks = 3